const fetchUsers = (state) => {
    state.isLoading = true
    state.error = null
    state.users = []
}

const fetchUsersSuccess = (state, users) => {
    state.isLoading = false
    state.error = null
    state.users = users
}

const fetchUsersError = (state, error) => {
    state.isLoading = false
    state.error = error
    state.users = []
}

const fetchUser = (state) => {
  state.isLoading = true
  state.error = null
  state.user = null
}

const fetchUserSuccess = (state, user) => {
  state.isLoading = false
  state.error = null
  state.user = user
}

const fetchUserError = (state, error) => {
  state.isLoading = false
  state.error = error
  state.user = null
}

const createUserSuccess = (state, user) => {
  state.isLoading = false
  state.error = null
  state.user = user
}

const createUserError = (state, error) => {
  state.isLoading = false
  state.error = error
}

const updateUserSuccess = (state, user) => {
  state.isLoading = false
  state.error = null
  state.user = user
}

const updateUserError = (state, error) => {
  state.isLoading = false
  state.error = error
}

export default {
    fetchUsers, fetchUsersSuccess, fetchUsersError, createUserSuccess, createUserError, fetchUser,
    fetchUserSuccess, fetchUserError, updateUserSuccess, updateUserError
}
